module.exports = __webpack_public_path__ + "static/media/baroda.4a2471af.png";